import React from "react";
import { Layout, Typography } from "antd";
import MainHeader, {
  MENU_FACTORY_WOOD_EXPORT,
} from "../components/common/MainHeader";
import { Media } from "../AppMedia";
import { useTranslation } from "react-i18next";
import FactoryWoodExportList from "../components/factory-wood-export/FactoryWoodExportList";

export default function FactoryWoodExportListView() {
  const { Content } = Layout;
  const { Title } = Typography;
  const { t } = useTranslation();

  return (
    <div>
      <MainHeader activeItem={MENU_FACTORY_WOOD_EXPORT} />

      <Content style={{ margin: "24px", marginTop: "7em" }}>
        <Title level={2}>{t("menus.wood_menus.factory_wood_export")}</Title>
        <Media greaterThanOrEqual="md">
          <FactoryWoodExportList />
        </Media>
      </Content>
    </div>
  );
}
